export const SelectedCountLabel = ({ count }: { count: number }) => {
  return (
    <span className='p-1 text-colorThemeTextMedium d-inline-block' style={{ minWidth: '80px' }}>
      {count} selected
    </span>
  );
};
